// extracted by mini-css-extract-plugin
export var productImage = "_rt-1";
export var viewLink = "_rt-2";
export var wishlistItem = "_rt-0";